import { memo } from "react";

import DrinkBar from "../DrinkBar/DrinkBar";

// container component for resulting cocktails
const DrinksResults = (props) => {
  const drinkItems = props.drinks.map((drink, index) => {
    return (
      <DrinkBar
        key={index}
        drink={drink}
      />
    );
  });
  return(drinkItems)
};

export default memo(DrinksResults);
